import { DialogPopupTypes } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
// import { RootStore } from 'mobx-stores/root-store'
import { StoreDTO, UserDTO } from 'models'
import { Api } from 'services'

export class ViewStorePageStore {
  private rootStore: any
  private storeApi: Api['storeApi']

  constructor(rootStore: any) {
    this.rootStore = rootStore
    this.storeApi = this.rootStore.generalStore.api.storeApi
    makeAutoObservable(this)
  }

  // OBSERVABLES
  public store: StoreDTO = null
  public addNewUserSuccess: boolean = null

  // ACTIONS
  private setStore = (store: StoreDTO): void => {
    this.store = store
  }

  private setNewUserStore = (addNewUserSuccess: boolean): void => {
    this.addNewUserSuccess = addNewUserSuccess
  }

  // METHODS
  public clearStore = (): void => {
    this.setStore(null)
  }

  public onPageMount = async (storeId: number | string): Promise<void> => {
    await this.rootStore.usersMainStore.loadUsers()
    const store = await this.rootStore.storesMainStore.getStoreById(storeId)
    if (!store) return
    this.setStore(store)
    this.rootStore.userSearchStore.setAreEntitiesLoaded(true)
  }

  private setStoreProps = (props: Partial<StoreDTO>): void => {
    this.setStore({ ...this.store, ...props })
  }

  public onAddUserClick = async (user: UserDTO): Promise<void> => {
    if (!this.store?.id || !user?.id) return
    const store = await this.storeApi.assignUser(this.store.id, user, {
      silentProcess: true
    })
    if (!store) return
    this.setNewUserStore(true)
    setTimeout(() => {
      this.setNewUserStore(false)
    }, 2000);
    this.setStoreProps({ users: store.users })
  }

  public onRemoveUserClick = async (user: UserDTO): Promise<void> => {
    if (!this.store?.id || !user?.id) return
    const store = await this.storeApi.removeUser(this.store.id, user.emailAddress, {
      silentProcess: true
    })
    if (!store) return
    this.setStoreProps({ users: store.users })
  }

  public onActivateClick = async (): Promise<void> => {
    const {
      generalStore: { openDialogPopup, closeDialogPopup, showSuccess },
      routingStore: { push }
    } = this.rootStore

    openDialogPopup({
      type: DialogPopupTypes.WARNING,
      message: `Are you sure you want to activate "${this.store.name}" store?`,
      closeButtonLabel: 'No',
      buttons: [
        {
          children: 'Yes',
          preset: 'primary',
          onClick: async () => {
            const store = await this.storeApi.activateStore(this.store.id)
            if (!store) {
              closeDialogPopup()
              return
            }
            push('/stores')
            closeDialogPopup()
            showSuccess(`"${store.name}" store has been activated successfully`)
          }
        }
      ]
    })
  }


  public onSuspendStoreClick = async (): Promise<void> => {
    const {
      generalStore: { openDialogPopup, closeDialogPopup, showSuccess },
      routingStore: { push }
    } = this.rootStore

    openDialogPopup({
      type: DialogPopupTypes.WARNING,
      message: `Are you sure you want to suspend "${this.store.name}" store?`,
      closeButtonLabel: 'No',
      buttons: [
        {
          children: 'Yes',
          preset: 'primary',
          onClick: async () => {
            const store = await this.storeApi.suspendStore(this.store.id)
            if (!store) {
              closeDialogPopup()
              return
            }
            push('/stores')
            closeDialogPopup()
            showSuccess(`"${store.name}" store has been suspended successfully`)
          }
        }
      ]
    })
  }

  // COMPUTED
  public get addedUsersToStore(): UserDTO[] {
    if (!this.store || !this.store.users) return []
    const users: UserDTO[] = []

    this.store.users.forEach(({ createdDate: addedToStoreDate, emailAddress }) => {
      const userDto = this.rootStore.usersMainStore.getUserByEmailAddress(emailAddress)
      if (userDto) {
        // apply the added to store date as created date
        users.push({
          ...userDto,
          created: new Date(addedToStoreDate).toISOString()
        })
      }
    })

    return users
  }

  public get newUserAdded(): boolean {
    return this.addNewUserSuccess
  }
}
